import { combineReducers } from '@reduxjs/toolkit';
import { baseApi } from '@/lib/api/baseApi';
import { sessionReducer } from '@/slices/auth';

// Combines the single RTK Query reducer with slice client-state reducers.
export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  session: sessionReducer,
});
